import { getDomainData } from './api';

export const AVAILABLE_DOMAIN_DATA = {
  cacheKey: 'AVAILABLE_DOMAIN_DATA',
  apiFunction: getDomainData
};
